export default "__VITE_ASSET__ELT40jnl__"